import { NamesContainer } from 'pages/Workshop/Transactions/components/NamesContainer';
import { Switch } from 'components-antd';

import { TransactionUserRoleMap } from 'settings/constants/transaction';
import { DescriptionPopover, Options } from './components';

import styles from './styles.module.scss';

export const formTableColumns = (setEditFormTask, handleRemove, onEditForm, isViewMode) => [
  {
    title: 'Task',
    key: 'Name',
    dataIndex: 'Name',
    width: 400,
    sorter: (a, b) => {
      if (a.Name < b.Name) return -1;
      if (a.Name > b.Name) return 1;
      return 0;
    },
    render: (value) => <strong>{value}</strong>,
  },
  {
    title: 'Due Date',
    dataIndex: 'dueDate',
    key: 'dueDate',
    render: (_, task) => {
      const dueDate = `${task.Initial}${task.Operator}${task.DueDate}`;
      return <span>{dueDate}</span>;
    },
  },
  {
    title: 'Assigned To',
    dataIndex: 'AssigneeRoles',
    key: 'AssigneeRoles',
    render: (_, task) => {
      const taskRoles = task.AssigneeRoles?.map((i) => TransactionUserRoleMap[i] || i) || [];
      return <NamesContainer names={taskRoles} maxDisplayCount={2} />;
    },
  },
  {
    title: 'Required',
    dataIndex: 'required',
    key: 'required',
    render: (_, form) => {
      return (
        <Switch
          checked={form.IsRequired}
          onChange={(checked) => {
            const formTemplate = {
              ...form,
              IsRequired: checked,
            };
            onEditForm(formTemplate, form?.index);
          }}
          disabled={isViewMode}
        />
      );
    },
  },
  {
    title: '',
    key: 'options',
    render: (_, form) => {
      return (
        <div className={styles.tableOptions}>
          <DescriptionPopover description={form?.Description} />
          <Options
            index={form?.index}
            editHandler={() => setEditFormTask(form?.index, form)}
            removeHandler={() => handleRemove(form?.index, form)}
            isViewMode={isViewMode}
          />
        </div>
      );
    },
  },
];
